import { defineElement, FC, useElement, useListen, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { useStylesheet } from '@utilities/hooks';

import style from './social.scss';

type SocialType = 'pinterest' | 'twitter' | 'facebook' | 'linkedIn' | 'email' | 'whatsapp';

const Social: FC = () => {
    const [type] = useProp<SocialType>('type', 'email');
    const [emailBody] = useProp<string>('emailBody', '');
    const [emailSubject] = useProp<string>('emailSubject', '');
    const [image] = useProp<string>('image', '');

    useStylesheet(style);

    const button = useElement<HTMLButtonElement>('[js-hook-social-button]');

    useListen(button, 'click', () => {
        switch (type) {
            case 'pinterest':
                openPinterest();
                break;
            case 'twitter':
                openTwitter();
                break;
            case 'facebook':
                openFacebook();
                break;
            case 'linkedIn':
                openLinkedIn();
                break;
            case 'whatsapp':
                openWhatsapp();
                break;
            case 'email':
                openEmail();
                break;
        }
    });

    function openFacebook() {
        openDialogue(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`);
    }

    function openTwitter() {
        openDialogue(`https://twitter.com/intent/tweet?text=${window.location.href}`);
    }

    function openPinterest() {
        openDialogue(
            `http://pinterest.com/pin/create/button/?url=${window.location.href}&media=${image}`,
        );
    }

    function openLinkedIn() {
        openDialogue(`https://www.linkedin.com/shareArticle?url=${window.location.href}`);
    }

    function openWhatsapp() {
        openDialogue(`https://web.whatsapp.com/send?text=${encodeURI(window.location.href)}`);
    }

    function openEmail() {
        window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    }

    function openDialogue(url: string) {
        window.open(encodeURI(url), 'Share', 'height=500,width=700');
    }

    return (
        <button class="c-social" js-hook-social-button>
            <slot></slot>
        </button>
    );
};

Social.props = {
    type: { type: String },
    emailBody: { type: String },
    emailSubject: { type: String },
    image: { type: String },
};

defineElement('bpd-social', Social, { useShadowDom: true });
